import React, { useRef, useState } from 'react';
import { nodesToPdf } from '../../utils/pdf';
import { reportChartsFor } from './reportCharts';

const fmt = (n) => (Math.round(n * 100) / 100).toFixed(2);

// The whole scorecard as one printable report — the consultant report/chart
// components for every element the client can see.
const FullReport = ({ groups, companyName, financialYear, beeLevel, onClose }) => {
  const sheetRef = useRef(null);
  const [downloading, setDownloading] = useState(false);

  const charts = reportChartsFor(groups.map((g) => g.key));

  const handleDownload = async () => {
    setDownloading(true);
    try {
      await nodesToPdf(sheetRef.current, `bbee-report-${companyName || 'summary'}.pdf`, { orientation: 'landscape' });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="cd-panel" style={{ '--a': 'var(--teal)' }}>
      <div className="cd-panel-head">
        <div className="cd-panel-htext">
          <div className="nm"><span className="dot" /> Full B-BBEE report</div>
          <div className="sub">{companyName} · {financialYear?.label}</div>
        </div>
        <div className="cd-panel-hmeta">
          <div className="pts">{beeLevel?.level || '—'}</div>
        </div>
        <button type="button" className="cd-panel-x" onClick={onClose} aria-label="Close">×</button>
      </div>

      <div className="cd-panel-body">
        <button type="button" className="cd-btn cd-btn--primary" onClick={handleDownload} disabled={downloading} style={{ marginBottom: 16 }}>
          {downloading ? 'Generating PDF…' : 'Download PDF'}
        </button>

        <div className="cd-report-sheet" ref={sheetRef}>
          <div className="rs-head">
            <h2>{companyName || 'B-BBEE Scorecard'}</h2>
            <p>{financialYear?.label}</p>
            {beeLevel && <p>{beeLevel.level} · {fmt(beeLevel.combined_points)} / {beeLevel.max_points} points</p>}
          </div>
          {charts.map(({ key, Chart }) => (
            <div key={key} className="cd-report-embed"><Chart /></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FullReport;
